import i18n from "../../plugins/I18nPlugin";

export function maxSizeRule(
  sizeInBytes = 2000000,
  message = "sign.SignDocumentForm.maxSize"
): (value: any) => boolean | string {
  return value => !value || value.size < sizeInBytes || String(i18n.tc(message));
}
